module.exports = __webpack_public_path__ + "assets/img/ec3bba16b8476f9e4adec71a2266a395.svg";